import type { GChipSelectorItem } from '~/components/common/GChipSelector/types'
import type {
  CartItem,
  MenuCategory,
  MenuItem,
  MenuItemChoice as MenuItemChoiceAPI,
  MenuItemExpanded as MenuItemExpandedAPI,
  MenuResponse
} from '~/types/api/data-contracts'

export type ProductAttributes = 'GFR' | 'DF' | 'V' | 'VE' | 'LC' | 'NA'

export enum ProductAttributeEnum {
  GlutenFree = 'GFR',
  DairyFree = 'DF',
  Vegan = 'VE',
  Vegetarian = 'V',
  LowCarb = 'LC'
}

export interface MenuState {
  activeCategory?: MenuCategory
  categoryFilters: GChipSelectorItem[]
  filterAttribute?: ProductAttributes
  menu?: MenuResponse
  fetching: { menu: boolean }
  fetchDidFail: { menu: boolean }
  lastUpdated: {
    menu?: number
  }
  lastFailed: {
    menu?: number
  }
}

export interface MenuMultiChoiceItem extends MenuItem {
  quantity?: number
}

export interface MenuItemChoice extends MenuItemChoiceAPI {
  items: MenuMultiChoiceItem[]
}

export interface MenuItemCustomChoice extends MenuItemChoiceAPI {
  cartItems: Array<CartItem | undefined>
}

export interface MenuItemExpanded extends MenuItemExpandedAPI {
  choices: MenuItemChoice[]
  multiChoices: MenuItemChoice[]
}
